import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { HolidayValue } from '../models/HolidayValue';
import { take, map } from 'rxjs/operators';
import { DataService } from './data.service';
import { ToastComponent } from '../shared/toast/toast.component';

@Injectable({
  providedIn: 'root'
})
export class HolidayValueService {
  holidayValueDoc: AngularFirestoreDocument<HolidayValue>;
  constructor(private firestore: AngularFirestore,public dataService: DataService,public toastComponent: ToastComponent) 
  {  this.toastComponent = toastComponent}
  holidayValue: HolidayValue = {
    berekeningMaandloon: "(maandwedde * 3 maand) / 13 weken per trimester) / Aantal werkdagen per week) dddm",
    berekeningUurloon: "(uurloon * aantal uur te werken per dag)",
  }
  
  getHolidayValue(id:string): Observable<HolidayValue>
  {
    return this.firestore.collection("HolidayValue").doc<HolidayValue>(id).get().pipe(take(1),
      map(queryResult => {
        if(queryResult.exists){
          const data = queryResult.data() as HolidayValue;
          const id = queryResult.id;
          this.dataService.holidayValue = data;
          return {id, ...data};
        }
        else{
          return null;
        }
      }));
  }
  async addHolidayValue()
  {
    let holidayValueId = '';
    await this.firestore.collection("HolidayValue").add(this.holidayValue).then(function(docRef){
      holidayValueId = docRef.id
    })
    return holidayValueId;
  }
    //Deze methode wordt alleen gebruikt wanneer de priveAdmin een nieuwe onderneming aanmaakt.
    updateNaToevoegen(id: string, ondernemingId:string, ondernemingNaam:string)
    {
      this.holidayValue.ondernemingId = ondernemingId;
      this.holidayValue.ondernemingNaam = ondernemingNaam
      this.holidayValue.id = id;
      this.updateHolidayValue(this.holidayValue);
    }
  async updateHolidayValue(holidayValue: HolidayValue) {
    try {
      this.holidayValueDoc = this.firestore.doc(`HolidayValue/${holidayValue.id }`);
      await this.holidayValueDoc.update(holidayValue);
      this.dataService.holidayValue = holidayValue
      this.toastComponent.showSuccess();
    } catch (err) {
      console.log(err);
    }
  }
  deleteHolidayValue(id: string){
    this.holidayValueDoc = this.firestore.doc(`HolidayValue/${id}`);
    this.holidayValueDoc.delete();
  }
}
